import useScrollReveal from '../hooks/useScrollReveal';

export default function MedalCard({ imageSrc, name, condition, color, delay = 0 }) {
  const [ref, visible] = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`medal-card ${visible ? 'entered' : ''}`}
      style={{
        borderColor: `${color}33`,
        animationDelay: `${delay}ms`,
      }}
    >
      <img
        src={imageSrc}
        alt={name}
        className={`medal-image ${visible ? 'entered' : ''}`}
        style={{ animationDelay: `${delay + 80}ms` }}
      />
      <div className="medal-name" style={{ color }}>{name}</div>
      <div className="medal-condition">{condition}</div>
    </div>
  );
}
